import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../app/actions/generalActions";
import {
  MixedWidget6,
  BaseTablesWidget6,
  StatsWidget11,
  StatsWidget12,
  StatsWidget10,
  ListsWidget14,
} from "../widgets";
import { StatsWidget13 } from "../widgets/stats/StatsWidget13";

export function CulinanDashboard() {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.baseInfo.roles }),
    shallowEqual
  );

  const dispatch = useDispatch();
  useEffect(() => {
    const query = {
      whereClause: "",
      whereClauseParameters: [],
      orderClause: "id asc ",
      skipCount: 0,
      takeCount: 5,
    };
    dispatch(actions.fetchObjects("api/role", currentState.name, query))
  }, [])


  return (
    <>
      {/* begin::Dashboard */}

      {/* begin::Row */}
      {/* <div className="row">
        <div className="col-xl-4">
          <MixedWidget6 className="gutter-b card-stretch" />
        </div>
        <div className="col-xl-8">
          <BaseTablesWidget6 className="gutter-b" />
        </div>
      </div> */}
      {/* end::Row */}

      {/* begin::Row */}
      {/* <div className="row">
        <div className="col-xl-3">
          <StatsWidget11
            className="gutter-b"
            symbolShape="circle"
            baseColor="dark"
            title=" حاضرین "
          />
        </div>
        <div className="col-xl-3">
          <StatsWidget10
            className="gutter-b card-stretch"
            symbolShape="circle"
            baseColor="danger"
            title=" غائبین "
          />
        </div>
        <div className="col-xl-3">
          <StatsWidget12
            className="gutter-b"
            symbolShape="circle"
            baseColor="dark"
            title=" غائبین موجه "
          />
        </div>
        <div className="col-xl-3">
          <StatsWidget13
            className="gutter-b"
            symbolShape="circle"
            baseColor="dark"
            title=" افرادی که امروز تردد نداشته اند "
          />
        </div>
      </div> */}
      {/* end::Row */}

      {/* begin::Row */}
      {/* <div className="row">
        <div className="col-lg-12 col-xxl-12">
          <AdvanceTablesWidget9 className="card-stretch gutter-b" />
        </div>
      </div> */}
      {/* end::Row */}

      {/* begin::Row */}
      {/* <div className="row">
        <div className="col-xl-6">
          <ListsWidget10 className="card-stretch gutter-b" />
        </div>
        <div className="col-xl-6">
          <BaseTablesWidget1 className="card-stretch gutter-b" />
        </div>
      </div> */}
      {/* end::Row */}

      {/* begin::Row */}
      {/* <div className="row">
        <div className="col-lg-4">
          <ListsWidget8 className="card-stretch gutter-b" />
        </div>
        <div className="col-lg-8">
          <BaseTablesWidget2 className="card-stretch gutter-b" />
        </div>
      </div> */}
      {/* end::Row */}

      {/* end::Dashboard */}
    </>
  );
}
